module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nlet label = ''\nif((model.projectMeta || {}).lastOfferTS){\nlabel = storage.__('hint.customers.order.lastOfferTS', { ts: utils.moment(model.projectMeta.lastOfferTS).format('DD.MM.YYYY [um] HH:mm') })\n}\n%><div><%= label %></div>"
  , __filename = "components/templates/customers/projects/offerTSLabel.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
let label = ''
if((model.projectMeta || {}).lastOfferTS){
label = storage.__('hint.customers.order.lastOfferTS', { ts: utils.moment(model.projectMeta.lastOfferTS).format('DD.MM.YYYY [um] HH:mm') })
}

    ; __line = 6
    ; __append("<div>")
    ; __append(escapeFn( label ))
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/customers/projects/offerTSLabel.ejs

}